<div class="product-modal">

  <!-- header -->
  <div class="row">
    <div class="col-12">
      <h3 class="text-manax m-0 mb-4">
        <span class="pull-right">
          <button mat-icon-button type="button" (click)="dialog.close()">
            <i class="material-icons">close</i>
          </button>
        </span>
        <span class="text-purple-manax text-capitalize title-modal">
          Usuario
        </span>
      </h3>
    </div>
  </div>

  <!-- body -->
  <div class="row" *ngIf="loading">
    <div class="col-12 mb-4">
      <div class="d-flex justify-content-center">
        <div class="spinner-border" role="status">
          <span class="sr-only">Loading...</span>
        </div>
      </div>
    </div>
  </div>

  <div class="row" *ngIf="!loading">
    <div class="col-12 user-content" [ngClass]="{darken: readOnly}" (click)="setEditable()">
      <form *ngIf="form" class="m-0" [formGroup]="form" (ngSubmit)="onSubmit()">

        <div class="row">
          <div class="col-md-12">
            <mat-form-field appearance="outline">
              <mat-label> Usuario / Email </mat-label>
              <input matInput name="username" formControlName="username" type="text" #nameInput [readonly]="readOnly"
                [ngClass]="{ 'is-invalid': submitted && f['name'].errors }">
            </mat-form-field>
            <mat-error *ngIf="submitted && f['username']?.errors?.['required']">
              Nombre de Usuario / Email Obligatorio
            </mat-error>
          </div>
        </div>

        <div class="row" *ngIf="!user?._id">
          <div class="col-md-12">
            <mat-form-field appearance="outline">
              <mat-label> Contraseña </mat-label>
              <input matInput name="password" formControlName="password" type="text" #nameInput [readonly]="readOnly"
                [ngClass]="{ 'is-invalid': submitted && f['name'].errors }">
            </mat-form-field>
            <mat-error *ngIf="submitted && f['password']?.errors?.['required']">
              Contraseña
            </mat-error>
          </div>
        </div>

        <div class="row" *ngIf="isManax">
          <div class="col-md-12">
            <mat-form-field appearance="outline">
              <mat-label>
                Empresas
              </mat-label>
              <mat-select name="company" formControlName="company" [disabled]="readOnly" multiple
                (ngModelChange)="changeOnCompanies()">
                <mat-option *ngFor="let company of companies" [value]="company._id">{{company.name}}
                </mat-option>
              </mat-select>
            </mat-form-field>
          </div>
        </div>

        <div class="row" *ngIf="f['company'] && (f['company']?.value?.length < 1)">
          <div class="col-md-12">
            <b>Seleccione una Empresa para vincular con un Trabajador</b><br><br>
          </div>
        </div>

        <div class="row" *ngIf="f['company'] && (f['company']?.value?.length > 1)">
          <div class="col-md-12">
            <b>Seleccione <u>sólo</u> una Empresa para vincular con un Trabajador</b><br><br>
          </div>
        </div>

        <div class="row"
          *ngIf="(f['company'] && (f['company']?.value?.length == 1) && (workers?.length)) || (!f['company'] && userCompanyId)">
          <div class="col-md-12">
            <mat-form-field appearance="outline">
              <mat-label>
                Trabajador
              </mat-label>
              <mat-select name="worker" formControlName="worker" [disabled]="readOnly">
                <mat-option *ngFor="let worker of workers" [value]="worker._id">{{worker.firstname}} {{worker.lastname}}
                </mat-option>
              </mat-select>
            </mat-form-field>
          </div>
        </div>

        <div class="row">
          <div class="col-md-12">
            <mat-form-field appearance="outline">
              <mat-label>
                Roles
              </mat-label>
              <mat-select name="roles" formControlName="roles" [disabled]="readOnly" multiple>
                <mat-option *ngFor="let role of roles" [value]="role._id">{{roleLabels[role.name || '']}}
                </mat-option>
              </mat-select>
            </mat-form-field>
          </div>
        </div>

        <div class="row" *ngIf="user._id && isDev">
          <div class="col-3">
            <label>
              Activo? <br>
              <input name="isActive" formControlName="isActive" type="checkbox" [disabled]="readOnly">
            </label>
          </div>
          <div class="col-3">
            <label>
              Borrada? <br>
              <input name="isDeleted" formControlName="isDeleted" type="checkbox" [disabled]="readOnly">
            </label>
          </div>
          <div class="col-6">
            <mat-form-field appearance="outline">
              <input matInput placeholder="Id" type="text" [value]="user._id" readonly>
            </mat-form-field>
          </div>
        </div>

        <div class="row" *ngIf="readOnly">
          <div class="col-12 pt-4">
            <button mat-raised-button [disabled]="saving" type="button" class="m-0 ml-1 pull-left btn btn-warning"
              (click)='changePassword()'>
              Cambiar Contraseña
            </button>
          </div>
        </div>

        <div class="row" *ngIf="!readOnly">
          <div class="col-12 pt-4">
            <button mat-raised-button [disabled]="saving" type="submit" class="m-0 ml-1 pull-right btn btn-manax">
              <span *ngIf="saving" class="spinner-border spinner-border-sm mr-1"></span>
              Guardar
            </button>
            <button mat-raised-button type="button" class="m-0 ml-1 pull-right btn btn-link"
              (click)="dialog.close(false)">
              Cancelar
            </button>
          </div>
        </div>
      </form>
    </div>
  </div>
</div>